import { render, staticRenderFns } from "./RubricSettings.vue?vue&type=template&id=65e3a040"
import script from "./RubricSettings.vue?vue&type=script&lang=js"
export * from "./RubricSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports